import React, { useState } from 'react';
import './LibraryRules.css';
import Footer from '../components/Footer';
import Navbar from '../components/navbar';
import CTAButton from '../components/sticky-button';
import PageHeader from '../about/PageHeader';
import { FaBookOpen, FaChartBar, FaClipboardList, FaClock } from 'react-icons/fa';

const LibraryRules = () => {
  const [activeTab, setActiveTab] = useState('July 2024 - June 2025');

  // DATA: Comprehensive Statistics Mapping
  const statsData = {
    'July 2024 - June 2025': {
      graphImage: '/Facilities/Library_timing_and_rules/imgi_3_no-of-volumes.webp',
      rows: [
        { month: 'Jul-24', faculty: 70, students: 260, digital: 151, total: 481, ebook: 211, ejournal: 129, issued: 54, returned: 188 },
        { month: 'Aug-24', faculty: 70, students: 215, digital: 123, total: 408, ebook: 223, ejournal: 272, issued: 64, returned: 47 },
        { month: 'Sep-24', faculty: 63, students: 283, digital: 99, total: 445, ebook: 193, ejournal: 96, issued: 34, returned: 12 },
        { month: 'Oct-24', faculty: 70, students: 443, digital: 165, total: 678, ebook: 277, ejournal: 218, issued: 384, returned: 73 },
        { month: 'Nov-24', faculty: 67, students: 321, digital: 127, total: 515, ebook: 263, ejournal: 632, issued: 35, returned: 24 },
        { month: 'Dec-24', faculty: 68, students: 293, digital: 88, total: 449, ebook: 288, ejournal: 2689, issued: 17, returned: 93 },
        { month: 'Jan-25', faculty: 69, students: 327, digital: 113, total: 509, ebook: 259, ejournal: 7697, issued: 0, returned: 194 },
        { month: 'Feb-25', faculty: 49, students: 89, digital: 12, total: 150, ebook: 265, ejournal: 496, issued: 52, returned: 183 },
        { month: 'Mar-25', faculty: 69, students: 310, digital: 91, total: 470, ebook: 301, ejournal: 992, issued: 18, returned: 69 },
        { month: 'Apr-25', faculty: 68, students: 231, digital: 90, total: 389, ebook: 299, ejournal: 243, issued: 91, returned: 147 },
        { month: 'May-25', faculty: 52, students: 215, digital: 29, total: 296, ebook: 287, ejournal: 959, issued: 43, returned: 20 },
        { month: 'Jun-25', faculty: 31, students: 98, digital: 8, total: 137, ebook: 278, ejournal: 1785, issued: 12, returned: 46 },
        { month: 'Total', faculty: 746, students: 3085, digital: 1096, total: 4927, ebook: 3144, ejournal: 16208, issued: 804, returned: 1096, isTotal: true }
      ]
    },
    'July 2023 - June 2024': {
      graphImage: '/Facilities/Library_timing_and_rules/imgi_4_usage.webp',
      rows: [
        { month: 'Jul-23', faculty: 75, students: 345, digital: 186, total: 606, ebook: 198, ejournal: 265, issued: 57, returned: 84 },
        { month: 'Aug-23', faculty: 68, students: 404, digital: 115, total: 587, ebook: 180, ejournal: 486, issued: 11, returned: 332 },
        { month: 'Sep-23', faculty: 70, students: 526, digital: 163, total: 759, ebook: 195, ejournal: 276, issued: 21, returned: 72 },
        { month: 'Oct-23', faculty: 70, students: 667, digital: 310, total: 1047, ebook: 187, ejournal: 386, issued: 166, returned: 59 },
        { month: 'Nov-23', faculty: 64, students: 475, digital: 271, total: 810, ebook: 222, ejournal: 736, issued: 606, returned: 102 },
        { month: 'Dec-23', faculty: 67, students: 603, digital: 290, total: 960, ebook: 210, ejournal: 501, issued: 74, returned: 99 },
        { month: 'Jan-24', faculty: 67, students: 438, digital: 188, total: 693, ebook: 527, ejournal: 340, issued: 16, returned: 129 },
        { month: 'Feb-24', faculty: 68, students: 267, digital: 150, total: 485, ebook: 130, ejournal: 784, issued: 43, returned: 736 },
        { month: 'Mar-24', faculty: 66, students: 357, digital: 183, total: 606, ebook: 906, ejournal: 279, issued: 229, returned: 218 },
        { month: 'Apr-24', faculty: 65, students: 326, digital: 156, total: 547, ebook: 234, ejournal: 557, issued: 54, returned: 46 },
        { month: 'May-24', faculty: 66, students: 513, digital: 270, total: 849, ebook: 784, ejournal: 248, issued: 90, returned: 70 },
        { month: 'Jun-24', faculty: 68, students: 336, digital: 156, total: 560, ebook: 339, ejournal: 1896, issued: 7, returned: 267 },
        { month: 'Total', faculty: 814, students: 5257, digital: 2438, total: 8509, ebook: 4112, ejournal: 6754, issued: 1374, returned: 2214, isTotal: true }
      ]
    },
    'Jan 2023 - Dec 2023': {
      graphImage: '/Facilities/Library_timing_and_rules/imgi_5_Library23-24.webp',
      rows: [
        { month: 'Jan-23', faculty: 56, students: 474, digital: 186, total: 716, ebook: 130, ejournal: 759, issued: 416, returned: 221 },
        { month: 'Feb-23', faculty: 58, students: 343, digital: 164, total: 565, ebook: 72, ejournal: 457, issued: 13, returned: 60 },
        { month: 'Mar-23', faculty: 56, students: 250, digital: 99, total: 405, ebook: 147, ejournal: 392, issued: 82, returned: 602 },
        { month: 'Apr-23', faculty: 57, students: 149, digital: 82, total: 288, ebook: 122, ejournal: 372, issued: 285, returned: 183 },
        { month: 'May-23', faculty: 53, students: 410, digital: 213, total: 676, ebook: 157, ejournal: 614, issued: 121, returned: 119 },
        { month: 'Jun-23', faculty: 58, students: 254, digital: 175, total: 487, ebook: 153, ejournal: 459, issued: 72, returned: 66 },
        { month: 'Jul-23', faculty: 75, students: 345, digital: 186, total: 606, ebook: 130, ejournal: 266, issued: 57, returned: 84 },
        { month: 'Aug-23', faculty: 68, students: 404, digital: 115, total: 587, ebook: 72, ejournal: 493, issued: 11, returned: 332 },
        { month: 'Sep-23', faculty: 70, students: 526, digital: 163, total: 759, ebook: 147, ejournal: 284, issued: 21, returned: 72 },
        { month: 'Oct-23', faculty: 70, students: 667, digital: 310, total: 1047, ebook: 122, ejournal: 395, issued: 166, returned: 59 },
        { month: 'Nov-23', faculty: 64, students: 475, digital: 271, total: 810, ebook: 157, ejournal: 768, issued: 606, returned: 102 },
        { month: 'Dec-23', faculty: 67, students: 603, digital: 290, total: 960, ebook: 153, ejournal: 512, issued: 74, returned: 99 },
        { month: 'Total', faculty: 752, students: 4900, digital: 2254, total: 7906, ebook: 1562, ejournal: 5771, issued: 1924, returned: 1999, isTotal: true }
      ]
    },
    'Jan 2022 - Dec 2022': {
      graphImage: '/Facilities/Library_timing_and_rules/imgi_6_library-usage-dec.webp',
      rows: [
        { month: 'Jan-22', faculty: 46, students: 129, digital: 10, total: 185, ebook: 106, ejournal: 385, issued: 23, returned: 243 },
        { month: 'Feb-22', faculty: 58, students: 114, digital: 24, total: 196, ebook: 89, ejournal: 270, issued: 598, returned: 169 },
        { month: 'Mar-22', faculty: 58, students: 77, digital: 60, total: 195, ebook: 118, ejournal: 1274, issued: 44, returned: 2 },
        { month: 'Apr-22', faculty: 57, students: 308, digital: 25, total: 390, ebook: 120, ejournal: 1403, issued: 0, returned: 1000 },
        { month: 'May-22', faculty: 61, students: 274, digital: 36, total: 371, ebook: 113, ejournal: 3384, issued: 40, returned: 75 },
        { month: 'Jun-22', faculty: 51, students: 357, digital: 44, total: 452, ebook: 141, ejournal: 864, issued: 17, returned: 0 },
        { month: 'Jul-22', faculty: 58, students: 385, digital: 145, total: 588, ebook: 137, ejournal: 1701, issued: 97, returned: 1 },
        { month: 'Aug-22', faculty: 57, students: 300, digital: 111, total: 468, ebook: 111, ejournal: 5513, issued: 46, returned: 0 },
        { month: 'Sep-22', faculty: 57, students: 677, digital: 184, total: 918, ebook: 109, ejournal: 4991, issued: 121, returned: 15 },
        { month: 'Oct-22', faculty: 56, students: 706, digital: 184, total: 946, ebook: 112, ejournal: 711, issued: 109, returned: 52 },
        { month: 'Nov-22', faculty: 59, students: 465, digital: 234, total: 758, ebook: 129, ejournal: 1313, issued: 27, returned: 42 },
        { month: 'Dec-22', faculty: 59, students: 369, digital: 211, total: 1485, ebook: 130, ejournal: 233, issued: 383, returned: 172 },
        { month: 'Total', faculty: 677, students: 4237, digital: 1268, total: 6952, ebook: 1415, ejournal: 6847, issued: 1560, returned: 2658, isTotal: true }
      ]
    }
  };

  return (
    <>
      <Navbar />
      <CTAButton />

      <div className="lib-rules-container">
        <PageHeader
          title="Library Timing and Rules"
          crumbs={[
            { label: "Home", href: "/" },
            { label: "Library Timing and Rules" },
          ]}
        />

        <main className="lib-rules-main">
          {/* Timing & Membership Rules Section */}
          <div className="lib-rules-top-grid">
            {/* 1. Library Timing */}
            <div className="lib-rules-card">
              <div className="lib-rules-card-header">
                <div className="lib-rules-icon-bg">
                  <FaClock aria-hidden="true" focusable="false" />
                </div>
                <h3>Library Timing</h3>
              </div>
              
              <div className="lib-rules-section-title">STUDENTS</div>
              <div className="lib-rules-timing-row">
                <span className="lib-rules-label">Reading Hall (Mon to Sat)</span>
                <span className="lib-rules-time">8.30 am to 6.00 pm</span>
              </div>
              <div className="lib-rules-timing-row">
                <span className="lib-rules-label">Book Issue / Return</span>
                <span className="lib-rules-time">9.00 am to 5.30 pm</span>
              </div>
              <div className="lib-rules-timing-row">
                <span className="lib-rules-label">Library Card Making</span>
                <span className="lib-rules-time">After Orientation</span>
              </div>

              <div className="lib-rules-section-title mt-6">STAFF</div>
              <div className="lib-rules-timing-row">
                <span className="lib-rules-label">Reading Hall</span>
                <span className="lib-rules-time">8.30 am to 6.00 pm</span>
              </div>
              <div className="lib-rules-timing-row">
                <span className="lib-rules-label">Book Issue / Return</span>
                <span className="lib-rules-time">9.00 am to 5.30 pm</span>
              </div>
              <div className="lib-rules-timing-row">
                <span className="lib-rules-label">Library Card Making</span>
                <span className="lib-rules-time">After Induction</span>
              </div>
            </div>

            {/* 2. Rules - Membership */}
            <div className="lib-rules-card">
              <div className="lib-rules-card-header">
                <div className="lib-rules-icon-bg">
                  <FaBookOpen aria-hidden="true" focusable="false" />
                </div>
                <h3>Rules – Membership</h3>
              </div>
              <div className="lib-rules-section-title">STUDENTS:</div>
              <ul className="lib-rules-list">
                <li>Each student gets three library cards; same will be used till final year.</li>
                <li>Against 2 library cards students can issue books for one week and 1 card can be used for Book Bank facility</li>
                <li>In case book is not returned before due date, fine of Rs.5/- is imposed per day (including holidays)</li>
                <li>Library cards are not transferable</li>
                <li>If library card is lost, the Librarian should be informed immediately. In genuine cases a duplicate set may be issued after giving an application to the Director and payment of Rs.50/-</li>
                <li>Lost book has to be replaced by new book or its equivalent cost has to be paid</li>
                <li>Book Bank Facility is given to all students. 4 – 7 books are given to every student for entire semester as per syllabus.</li>
              </ul>
              <div className="lib-rules-section-title mt-4">ISSUES OF JOURNALS AND MAGAZINES</div>
              <ul className="lib-rules-list">
                <li>Current journals and magazines are not issued and have to be used in the library only.</li>
                <li>Back issues of journals and magazines can be issued for one week.</li>
                <li>Provide scan copy of current journal article for research work if demand</li>
              </ul>
            </div>
          </div>

          {/* 3. General Instructions */}
          <div className="lib-rules-card lib-rules-full-width">
            <div className="lib-rules-card-header">
              <div className="lib-rules-icon-bg">
                <FaClipboardList aria-hidden="true" focusable="false" />
              </div>
              <h3>General Instructions</h3>
            </div>
            <ul className="lib-rules-list grid-list">
              <li>Faculty / student can recommend useful books by filling Book Requisition Form / Books recommended by members added in collection with approval of Director.</li>
              <li>Books exhibition is organized every year. Students, faculty and staff members visit and select books for library.</li>
              <li>New arrivals of books, e-journals access instructions and links, overdue reminder list is displayed on notice board</li>
              <li>Students are not allowed to sit in the library while lectures / practicals are going on.</li>
              <li>All library materials –books, journals, magazines, newspapers and non-print material must be used carefully</li>
              <li>Possession/ wearing of valid Institute ID is compulsory</li>
              <li>Writing or marking in the library books is strictly prohibited</li>
              <li>Fans & tube lights must be switched off on leaving library.</li>
              <li>Bags must be kept on the luggage rack.</li>
              <li>Phones have to kept in silent mode in the library</li>
              <li>Silence and discipline has to be maintained in the library.</li>
              <li>Eatables are strictly prohibited in the library.</li>
            </ul>
          </div>

          {/* 4. Usage Statistics */}
          <div className="lib-rules-card lib-rules-full-width">
            <div className="lib-rules-card-header">
              <div className="lib-rules-icon-bg">
                <FaChartBar aria-hidden="true" focusable="false" />
              </div>
              <h3>Library Usage Statistics</h3>
            </div>

            <div className="lib-rules-tabs">
              {Object.keys(statsData).map((key) => (
                <button 
                  key={key} 
                  className={`lib-rules-tab-btn ${activeTab === key ? 'active' : ''}`}
                  onClick={() => setActiveTab(key)}
                >
                  {key}
                </button>
              ))}
            </div>

            <div className="table-container">
              <table className="responsive-table">
                <thead>
                  <tr>
                    <th>Month</th>
                    <th>
                      <span className="lib-rules-desktop-label">Total No. of Faculty Visited Library</span>
                      <span className="lib-rules-mobile-label">Faculty</span>
                    </th>
                    <th>
                      <span className="lib-rules-desktop-label">Total No. of Students Visited Library</span>
                      <span className="lib-rules-mobile-label">Students</span>
                    </th>
                    <th>
                      <span className="lib-rules-desktop-label">Total No. of Visitors Digital Library</span>
                      <span className="lib-rules-mobile-label">Digital</span>
                    </th>
                    <th>
                      <span className="lib-rules-desktop-label">Total Number of Visitors</span>
                      <span className="lib-rules-mobile-label">Total</span>
                    </th>
                    <th>
                      <span className="lib-rules-desktop-label">No of users Digital e-Books</span>
                      <span className="lib-rules-mobile-label">e-Books</span>
                    </th>
                    <th>
                      <span className="lib-rules-desktop-label">No of users Digital e-Journal</span>
                      <span className="lib-rules-mobile-label">e-Journal</span>
                    </th>
                    <th>
                      <span className="lib-rules-desktop-label">Books Issued Koha</span>
                      <span className="lib-rules-mobile-label">Issued</span>
                    </th>
                    <th>
                      <span className="lib-rules-desktop-label">Books Returned Koha</span>
                      <span className="lib-rules-mobile-label">Returned</span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {statsData[activeTab].rows.map((row, index) => (
                    <tr key={index} className={row.isTotal ? 'lib-rules-row-total' : ''}>
                      <td>{row.month}</td>
                      <td>{row.faculty}</td>
                      <td>{row.students}</td>
                      <td>{row.digital}</td>
                      <td>{row.total}</td>
                      <td>{row.ebook}</td>
                      <td>{row.ejournal}</td>
                      <td>{row.issued}</td>
                      <td>{row.returned}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            
            <div className="lib-rules-chart-container">
              <div className="lib-rules-section-title" style={{textAlign: 'center', marginTop: '2rem'}}>
                Trend Analysis: {activeTab}
              </div>
              <img 
                src={statsData[activeTab].graphImage} 
                alt={`Usage Statistics Graph for ${activeTab}`} 
                className="lib-rules-chart-image" 
              />
            </div>
          </div>
        </main>
      </div>

      <Footer />
    </>
  );
};

export default LibraryRules;
